export default __webpack_public_path__ + "static/media/lmao.ff9e0002.png";